
let React =         require("react");
let ContentServerClient = require("../../ContentServerClient.js");
let Loading = require("../modals/Loading.jsx");
let Iframe = require("./Iframe.jsx");
let CircuitsUtil = require("../../util/CircuitsUtil.js");
let ApplicationContext =  require("../../config/ApplicationContext.js");

class PackagePreview extends React.Component {

    constructor() {
        super();
    }


    render() {
        const { resource } = this.props;

        return <Iframe base={ApplicationContext.getPackageEditor()} id={resource.id} version={CircuitsUtil.getMostRecentVersion(resource)}/>
    }
}

module.exports = PackagePreview;
